import { Box, Button } from '@mui/material'
import { stepStyles } from './stepStyles'

interface Props {
  onBack: () => void
  onContinue: () => void
  backTestId: string
  continueTestId: string
  continueDisabled?: boolean
}

export const WizardFooter = ({ onBack, onContinue, backTestId, continueTestId, continueDisabled = false }: Props): JSX.Element => (
  <Box sx={stepStyles.footer}>
    <Button variant='contained' onClick={onBack} data-testid={backTestId} sx={stepStyles.backButton}>Back</Button>
    <Button variant='contained' disabled={continueDisabled} onClick={onContinue} data-testid={continueTestId} sx={stepStyles.continueButton}>Continue</Button>
  </Box>
)
